import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { Carousel } from 'react-responsive-carousel'
import Loader from '../UI/Loader'
import GuruProfileAbout from './GuruProfileAbout'
import GuruProfileServices from './GuruProfileServices'
import Reviews from './Reviews'
import ChooseDatesModal from './CreateGuruProfile/ChooseDatesModal'
import 'react-responsive-carousel/lib/styles/carousel.css'
import USER_FULL_INFO from './../../graphql/UserFullInfoById.graphql'
import USER_INFO from './../../graphql/User.graphql'
import moment from 'moment'
import _ from 'lodash'
import SingleChat from '../Chat/SingleChat'
import searchStore from '../../mobx-store/search-store'
import { showSignup } from '../../libs/authService';


class FinishPage extends React.Component {
  state = {
    isOpen: false,
    startDate: null,
    endDate: null,
    countOfTripDays: null,
    optimalPlan: null,
    selectedPlan: null,
    flexDays: '',
    options: [],
    chatIsOpend: false,
    country: null
  }

  componentWillMount() {
    if (!this.props.userInfo.loading && !this.props.userInfo.User.plannerProfile) {
      this.props.history.push('/create-guru-profile/description')
    }
    const matchProps = {
      country: searchStore.pickedPlace.country,
      startDate: searchStore.rangeDate.startDate ? moment(searchStore.rangeDate.startDate) : null,
      endDate: searchStore.rangeDate.endDate ? moment(searchStore.rangeDate.endDate) : null
    }
    this.setState(matchProps)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.startDate && this.state.endDate) {
      this.getCountTripDays()
    }
  }


  getCountTripDays = () => {
    const countOfTripDays =
      this.state.endDate && this.state.startDate && moment(this.state.endDate).diff(moment(this.state.startDate), 'days')
    this.setState({ countOfTripDays: countOfTripDays }, () => this.getOptimalPlan())
  }

  getCoutnFlexDays = () => {
    this.setState({ countOfTripDays: this.state.flexDays }, () => this.getOptimalPlan())
  }

  handleOpenChat = () => {
    this.setState({
      chatIsOpend: !this.state.chatIsOpend
    })
  }

  closeChat = () => {
    this.setState({
      chatIsOpend: false
    })
  }

  getOptimalPlan = () => {
    const { countOfTripDays } = this.state
    const arr = []
    if (Number(countOfTripDays) % 7 === 0) {
      arr.push('PayOneWeekPeriod')
    }
    if (Number(countOfTripDays) % 14 === 0) {
      arr.push('PayTwoWeekPeriod')
    }
    if (Number(countOfTripDays) % 21 === 0) {
      arr.push('PayThreeWeekPeriod')
    }
    if (Number(countOfTripDays) >= 28 && Number(countOfTripDays) <= 31) {
      arr.push('PayForMonth')
    }
    if (Number(countOfTripDays) > 31) {
      arr.push('PayForMoreThanMonth')
    }
    arr.push('PayPerDay')
    this.setState(
      {
        optimalPlan: arr
      },
      this.fillMapOptions
    )
  }

  calculatePrice = arg => {
    switch (arg.paymentStructure) {
      case 'PayPerDay':
        return arg.price * this.state.countOfTripDays
        break
      case 'PayOneWeekPeriod':
        return arg.price * this.state.countOfTripDays / 7
        break
      case 'PayTwoWeekPeriod':
        return arg.price * this.state.countOfTripDays / 14
        break
      case 'PayThreeWeekPeriod':
        return arg.price * this.state.countOfTripDays / 21
        break
      case 'PayForMonth':
        return arg.price
        break
      case 'PayForMoreThanMonth':
        return arg.price
        break
      default:
        break
    }
  }

  sortPlans = (a, b) => {
    return this.calculatePrice(a) - this.calculatePrice(b)
  }

  handleSubmit = () => { 
    if (!this.props.userProfile.user) {
        // No user logged in
        showSignup(window.location.pathname)
    }
    else if (!this.state.selectedPlan) {
      this.props.history.push('/booking-steps/' + this.props.userInfo.User.id, {
        plan: this.state.options[0],
        countOfTripDays: this.state.countOfTripDays,
        currency: this.props.userInfo.User.plannerProfile.currency,
        startDate: this.state.startDate.toDate(),
        endDate: this.state.endDate.toDate()
      })
    } else {
      this.props.history.push('/booking-steps/' + this.props.userInfo.User.id, {
        plan: this.state.selectedPlan,
        countOfTripDays: this.state.countOfTripDays,
        currency: this.props.userInfo.User.plannerProfile.currency,
        startDate: this.state.startDate.toDate(),
        endDate: this.state.endDate.toDate()
      })
    }
  }
  /*eslint no-unreachable: "off"*/

  getPaymentCategoryName = paymentCategory => {
    switch (paymentCategory) {
      case 'PayOneWeekPeriod':
        return 'Pay One Week Period'
        break
      case 'PayTwoWeekPeriod':
        return 'Pay Two Week Period'
        break
      case 'PayThreeWeekPeriod':
        return 'Pay Three Week Period'
        break
      case 'PayForMonth':
        return 'Pay For Month'
        break
      case 'PayPerDay':
        return 'Pay Per Day'
        break
      default:
        return paymentCategory
    }
  }

  fillMapOptions = () => {
    const locationData = this.state.country
    this.state.endDate &&
      this.setState({
        options:
          this.props.userInfo &&
          this.props.userInfo.User &&
          this.props.userInfo.User.plannerProfile &&
          this.props.userInfo.User.plannerProfile.planOffers &&
          this.props.userInfo.User.plannerProfile.planOffers.length &&
          this.props.userInfo.User.plannerProfile.planOffers
            .filter(plan => {
              if (locationData) {
                return (
                  plan.location.country === locationData &&
                  this.state.optimalPlan.includes(plan.paymentStructure) &&
                  plan.status !== 'Deleted'
                )
              } else {
                return this.state.optimalPlan.includes(plan.paymentStructure) && plan.status !== 'Deleted'
              }
            })
            .sort(this.sortPlans)
      })
  }

  render() {
    const { t } = this.props
    if (this.props.userInfo.loading || this.props.userProfile.loading) {
      return <Loader showLoader={true} />
    }
    const user = this.props.userInfo.user

    return !!user ? (
      <div className="steps-screen" style={{ marginTop: 22 }}>
        <div className="steps-screen__guru-profile-container row overview">
          <div className="guru-profile ">
            <div className="guru-profile__left-column">
              <GuruProfileAbout guruId={this.props.match.params.id} showChatBox={this.handleOpenChat} user={user} t={t} />
              {this.state.chatIsOpend && (
                <SingleChat
                  user={this.props.userProfile.user}
                  recipientId={this.props.userInfo.user.id}
                  handleOpenChat={this.handleOpenChat}
                />
              )}
              <GuruProfileServices user={user} />
              <Reviews user={user} />
            </div>
            <div className="guru-profile__right-column" style={{ maxWidth: 450 }}>
              {this.props.userInfo &&
              this.props.userInfo.User &&
              this.props.userInfo.User.plannerProfile &&
              this.props.userInfo.User.plannerProfile.photos &&
              this.props.userInfo.User.plannerProfile.photos.length ? (
                <div className="finishPage__carousel">
                  <Carousel showArrows={true} showStatus={false} showThumbs={false} autoPlay={true} emulateTouch={true}>
                    {this.props.userInfo.user.plannerProfile.photos.map((photo, index) => (
                      <div className="carouselPhoto" key={index}>
                        <img src={photo.s3Url} alt="" />
                      </div>
                    ))}
                  </Carousel>
                </div>
              ) : (
                <div />
              )}
              {this.state.optimalPlan && (
                <select
                  id="finish-select"
                  className="guru-profile__select-booking-info"
                  onChange={e =>
                    this.setState({
                      selectedPlan: this.state.options[e.target.selectedIndex]
                    })
                  }
                >
                  {this.state.options &&
                    this.state.options.length > 0 &&
                    _.uniqBy(this.state.options, e => e.location.country).map((plan, index) => {
                      return (
                        <option id={index} key={index}>{`${plan.location.country}, ${this.props.userInfo.User.plannerProfile.currency}, ${
                          plan.price
                        }, ${this.getPaymentCategoryName(plan.paymentStructure)}`}</option>
                      )
                    })}
                </select>
              )}
              {this.state.flexDays !== '' &&
                this.state.flexDays !== '0' && (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>
                    {this.state.flexDays} day(s)
                  </button>
                )}
              {(this.state.flexDays === '' || this.state.flexDays === '0') &&
                (this.state.startDate && this.state.endDate && this.state.flexDays !== '0' ? (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>{`${moment(
                    this.state.startDate
                  ).format('DD.MM.YYYY')} - ${moment(this.state.endDate).format('DD.MM.YYYY')}`}</button>
                ) : (
                  <button className="btn btn-sm btn-primary" onClick={() => this.setState({ isOpen: true })}>
                    Choose your dates
                  </button>
                ))}
              {((this.state.startDate && this.state.endDate) || this.state.flexDays >= 1) && (
                <button className="btn btn-sm btn-primary btn-danger" onClick={this.handleSubmit}>
                  Start your booking
                </button>
              )}
            </div>
          </div>
          <ChooseDatesModal
            isOpen={this.state.isOpen}
            onClose={() => this.setState({ isOpen: false })}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={({ startDate, endDate }) => {
              this.setState({ startDate, endDate }, () => this.getCountTripDays())
            }}
            displayFormat={'MMM DD'}
            flexDays={this.state.flexDays}
            onFlexChange={e => this.setState({ flexDays: e.target.value }, () => this.getCoutnFlexDays())}
            clearFlex={() => this.setState({ flexDays: '', startDate: null, endDate: null })}
          />
        </div>
      </div>
    ) : null
  }
}

export default compose(
  translate('guru'),
  graphql(USER_INFO, {
    name: 'userProfile',
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  graphql(USER_FULL_INFO, {
    name: 'userInfo',
    options: ownProps => ({
      fetchPolicy: 'network-only',
      variables: { id: ownProps.match.params.id }
    })
  })
)(FinishPage)




// WEBPACK FOOTER //
// src/components/Guru/GuruById.js